import type { RoundPlayer } from '../../api/client.js';
import type { WorldState } from '../RoundScreen.js';

export function Rankings({
  state,
  player,
}: {
  state: WorldState;
  player: RoundPlayer;
}) {
  const dynasties = Object.values(state.entities.dynasties).filter((d) => d.status === 'active');

  // חסידים per dynasty
  const followersPerDyn = new Map<string, number>();
  for (const f of state.followers) {
    followersPerDyn.set(f.dynastyId, (followersPerDyn.get(f.dynastyId) ?? 0) + f.count);
  }

  const rows = dynasties.map((d) => ({
    id: d.id,
    name: d.name,
    isPlayer: d.id === player.dynasty_id,
    isHuman: d.isPlayer,
    ethnicity: d.ethnicity,
    stream: d.stream,
    followers: followersPerDyn.get(d.id) ?? 0,
    reputation: d.reputation,
    gold: d.resources.gold,
  }));

  // 3 מיונים
  const byFollowers = [...rows].sort((a, b) => b.followers - a.followers);
  const byReputation = [...rows].sort((a, b) => b.reputation - a.reputation);
  const byGold = [...rows].sort((a, b) => b.gold - a.gold);

  return (
    <div className="rankings">
      <div className="rankings-grid">
        <RankingsTable title="👥 הכי הרבה חסידים" rows={byFollowers} valueKey="followers" fmt={numFmt} />
        <RankingsTable title="⭐ הכי הרבה מוניטין" rows={byReputation} valueKey="reputation" fmt={numFmt} />
        <RankingsTable title="💰 הכי עשירים" rows={byGold} valueKey="gold" fmt={goldFmt} />
      </div>
    </div>
  );
}

type Row = {
  id: string;
  name: string;
  isPlayer: boolean;
  isHuman: boolean;
  ethnicity: string;
  stream: string;
  followers: number;
  reputation: number;
  gold: number;
};

function RankingsTable({
  title,
  rows,
  valueKey,
  fmt,
}: {
  title: string;
  rows: Row[];
  valueKey: keyof Pick<Row, 'followers' | 'reputation' | 'gold'>;
  fmt: (n: number) => string;
}) {
  return (
    <div className="rankings-table">
      <h2>{title}</h2>
      <ol>
        {rows.slice(0, 20).map((r, idx) => (
          <li key={r.id} className={r.isPlayer ? 'me' : ''}>
            <span className="rank">#{idx + 1}</span>
            <span className="name">
              {r.name}
              {r.isHuman && !r.isPlayer && <span className="badge human">👤</span>}
              {r.isPlayer && <span className="badge me-badge">אתה</span>}
            </span>
            <span className="val">{fmt(r[valueKey])}</span>
          </li>
        ))}
      </ol>
    </div>
  );
}

function numFmt(n: number): string {
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + 'M';
  if (n >= 1000) return (n / 1000).toFixed(1) + 'K';
  return n.toLocaleString('he-IL');
}
function goldFmt(n: number): string {
  return '💰 ' + numFmt(n);
}
